import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";

import { getSecurityOverview } from "@/lib/security-alerts.functions";
import { AdminNav } from "@/components/admin/AdminNav";

export const Route = createFileRoute("/_authenticated/admin/seguridad")({
  head: () => ({ meta: [{ title: "Seguridad y alertas — Admin" }, { name: "robots", content: "noindex" }] }),
  component: SecurityPage,
});

function List({ title, items }: { title: string; items: string[] }) {
  return (
    <div className="rounded-xl border bg-card p-4">
      <div className="flex justify-between text-sm font-medium">
        <span>{title}</span>
        <span className={items.length ? "text-destructive" : "text-primary"}>{items.length ? items.length : "OK"}</span>
      </div>
      {items.length > 0 && <ul className="mt-2 list-disc pl-5 text-xs text-muted-foreground">{items.map((i) => <li key={i}>{i}</li>)}</ul>}
    </div>
  );
}

function SecurityPage() {
  const q = useQuery({ queryKey: ["security-overview"], queryFn: () => getSecurityOverview() });
  const d = q.data;
  return (
    <div className="mx-auto max-w-5xl space-y-6 px-4 py-8">
      <AdminNav />
      <h1 className="text-2xl font-semibold">Seguridad y alertas</h1>
      {q.isLoading && <p className="text-sm text-muted-foreground">Revisando…</p>}
      {d && !d.ok && <p className="rounded-md bg-destructive/10 p-3 text-sm text-destructive">{d.error}</p>}
      {d?.ok && d.posture && (
        <>
          <p className="text-sm text-muted-foreground">
            Revisado: {new Date(d.posture.checked_at).toLocaleString("es-MX")}
            {d.alertQueued ? " · Se envió una alerta al propietario." : ""}
          </p>
          <div className="grid gap-3 sm:grid-cols-2">
            <List title="Tablas sin protección por filas" items={d.posture.tables_without_rls} />
            <List title="Funciones privilegiadas abiertas a visitantes" items={d.posture.definer_exec_by_anon} />
            <List title="Funciones privilegiadas sin ruta fija" items={d.posture.definer_without_search_path} />
            <List title="Permisos de escritura anónima" items={d.posture.anon_write_grants} />
          </div>
          <h2 className="pt-4 text-lg font-semibold">Cambios administrativos y fallos recientes</h2>
          <div className="overflow-x-auto rounded-xl border">
            <table className="w-full text-left text-xs">
              <thead className="bg-muted/50"><tr><th className="p-2">Fecha</th><th className="p-2">Usuario</th><th className="p-2">Acción</th><th className="p-2">Objeto</th><th className="p-2">Resultado</th></tr></thead>
              <tbody>
                {(d.events ?? []).map((e, i) => (
                  <tr key={i} className="border-t">
                    <td className="p-2 whitespace-nowrap">{new Date(e.at).toLocaleString("es-MX")}</td>
                    <td className="p-2">{e.actor_email ?? "—"}</td>
                    <td className="p-2">{e.action}</td>
                    <td className="p-2">{e.entity ?? "—"}</td>
                    <td className={`p-2 ${e.result === "ok" ? "" : "text-destructive"}`}>{e.result}</td>
                  </tr>
                ))}
                {!d.events?.length && <tr><td className="p-3 text-muted-foreground" colSpan={5}>Sin eventos sensibles.</td></tr>}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
